<template>
    <div class="msg-box-scroll-wrapper" ref="msg-box-scroll-wrapper">
        <div class="msg-top-mask" v-if="msgBoxScrollTop>80"></div>
        <div class="msg-bottom-mask-box" v-if="msgHeight>boxHeight && msgHeight-msgBoxScrollTop-boxHeight>24">
            <div class="msg-bottom-mask-content">
                <div class="msg-bottom-mask">
                </div>
            </div>
        </div>
        <ElScrollbar ref="elScrollbar">
            <div
                class="msg-box-scroll"
                ref="scrollContent"
            >
                <div
                    class="msg-box-wrapper"
                    ref="msgBox"
                >
                    <div class="msg-top-placeholder"></div>
                    <slot></slot>
                </div>
            </div>
        </ElScrollbar>
    </div>
</template>
<script>
export default {
    name: 'MsgBoxScroll',
    data () {
        return {
            observer: null,
            msgBoxScrollTop: 0,
            boxHeight: 0,
            msgHeight: 0
        };
    },
    mounted () {
        this.init();
    },
    methods: {
        init () {
            // 监听内容高度变化并滚动到底部
            // 创建 ResizeObserver 实例
            this.observer = new ResizeObserver(() => {
                // 当元素大小发生变化时，执行以下操作
                this.scrollToBottom();
            });

            // 监听 content 的大小变化
            this.observer.observe(this.$refs.msgBox);

            // 监听滚动，判断是否显示遮罩层
            this.$refs.elScrollbar.wrap.onscroll = (e) => {
                this.msgBoxScrollTop = e.target.scrollTop;
                this.boxHeight = this.$refs['msg-box-scroll-wrapper'].offsetHeight;
                this.msgHeight = e.target.scrollHeight;
            };
        },
        //  滚动到底部函数
        scrollToBottom () {
            this.$refs.elScrollbar.$refs.wrap.scrollTop = this.$refs.msgBox.scrollHeight;
        }
    },
    beforeDestroy () {
        this.observer.disconnect();
        this.observer = null;
    }
};
</script>
<style lang="scss">
.msg-box-scroll-wrapper {
    height: 100%;
    width: 100%;
    position: relative;

    >.el-scrollbar {
        height: 100%;
    }
    .msg-top-mask{
        z-index: 1;
        width: 100%;
        height: 64px;
        position: absolute;
        top: 0;
        background: var(--mask-bg-top);
    }
    .msg-bottom-mask-box{
        z-index: 1;
        width: 100%;
        height: 56px;
        position: absolute;
        bottom: 12px;
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        .msg-bottom-mask-content{
            flex: 0 0 auto;
            width: 100%;
            max-width: 1000px;
            display: flex;
            flex-flow: row nowrap;
            justify-content: center;
            padding: 0 58px;
            .msg-bottom-mask{
                width: 100%;
                background: var(--mask-bg-bottom);
            }
        }
    }
}

.msg-box-scroll {
    width: 100%;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    padding-bottom: 22px;
}

.msg-box-wrapper {
    width: 100%;
    max-width: 1000px;
}

.msg-group-wrapper {
    width: 100%;
    display: flex;
    flex-flow: column nowrap;

    >div {
        width: 100%;
    }
}

.msg-wrapper {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-start;
    justify-content: center;

    .msg-placeholder {
        flex: 0 0 52px;
        padding: 0 6px;

        >div {
            width: 40px;
            height: 40px;
            border-radius: 40px;
        }

        >img {
            width: 40px;
        }
    }

    .msg-content-box {
        flex: 1 1 auto;
        margin-bottom: 16px;
        box-sizing: border-box;
        padding: 0 6px;
        overflow: hidden;
    }
}

.msg-top-placeholder {
    height: 40px;
}
</style>
